import { isServerside } from '../core/utils/isServerside';

export enum CookieKeys {
  GA = '_ga',
  KIOSQ = 'kiosq_user',
  FTR_COUNTRY_CODE = 'FTR_Country_Code',
  REVIEW_TAB = 'hawk-review-widget-tab',
}

export const getCookie = (cookieKey: string): string | undefined => {
  if (isServerside()) {
    return undefined;
  }
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${cookieKey}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() ?? '';
  }
  return undefined;
};
